import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";

import aboutHero from "../assets/hero1.webp";

function Gallary() {
    const [galleryImages, setGalleryImages] = useState([]);
    const [selectedImg, setSelectedImg] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        AOS.init({ duration: 900, once: true });

        const fetchGalleryImages = async () => {
            try {
                const q = query(
                    collection(db, "gallery"),
                    orderBy("createdAt", "desc")
                );
                const snapshot = await getDocs(q);

                const images = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));

                setGalleryImages(images);
            } catch (error) {
                console.error("Error loading gallery images:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchGalleryImages();
    }, []);

    return (
        <div className="w-full overflow-hidden">
            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[40vh] w-full">
                <img
                    src={aboutHero}
                    alt="Gallery Hero"
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60" />
                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white px-4">
                    <h1
                        data-aos="fade-up"
                        className="text-4xl border border-[#c97b3a] bg-black/40 backdrop-blur-sm p-6 sm:p-5 sm:text-3xl md:text-4xl font-bold mb-3"
                    >
                        Gallery
                    </h1>
                </div>
            </section>

            {/* ================= GALLERY SECTION ================= */}
            <section className="py-12 bg-white">
                <div className="max-w-7xl mx-auto px-4">
                    <span className="block w-20 h-[2px] bg-orange-400 mx-auto mb-4"></span>

                    <div className="text-center mb-12">
                        <h2
                            data-aos="fade-up"
                            className="text-3xl md:text-5xl font-bold text-gray-800"
                        >
                            Our Moments
                        </h2>
                        <p
                            data-aos="fade-up"
                            data-aos-delay="150"
                            className="mt-6 text-gray-600 leading-relaxed text-base sm:text-lg md:text-xl"
                        >
                            Explore the beauty, comfort, and unforgettable experiences of our Cabana.
                        </p>
                    </div>

                    {/* Loading */}
                    {loading && (
                        <p className="text-center text-gray-500">Loading images...</p>
                    )}

                    {/* Gallery Grid */}
                    {!loading && (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                            {galleryImages.map((img, index) => (
                                <div
                                    key={img.id}
                                    data-aos="zoom-in"
                                    data-aos-delay={index * 80}
                                    className="group relative overflow-hidden rounded-xl shadow-lg cursor-pointer"
                                    onClick={() => setSelectedImg(img.imageUrl)}
                                >
                                    <img
                                        src={img.imageUrl}
                                        alt={`Gallery ${index + 1}`}
                                        loading="lazy"
                                        className="w-full h-[260px] object-cover transition-transform duration-500 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition duration-500" />
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* ================= MODAL ================= */}
                {selectedImg && (
                    <div
                        className="fixed inset-0 bg-black/70 flex justify-center items-center z-50 p-4"
                        onClick={() => setSelectedImg(null)}
                    >
                        <div className="relative">
                            <button
                                onClick={() => setSelectedImg(null)}
                                className="absolute -top-4 -right-4 bg-white text-black rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold shadow-lg hover:bg-gray-200 transition z-50"
                            >
                                &times;
                            </button>

                            <img
                                src={selectedImg}
                                alt="Expanded"
                                onClick={(e) => e.stopPropagation()}
                                className="
                                    rounded-lg shadow-lg
                                    w-full
                                    max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-3xl
                                    max-h-[80vh] object-contain
                                "
                            />
                        </div>
                    </div>
                )}
            </section>

            {/* ================= WHATSAPP FLOAT BUTTON ================= */}
            <a
                href="https://wa.me/94705108633?text=I%20saw%20your%20website.%20Can%20you%20give%20me%20information%20regarding%20your%20Cabana."
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition hover:scale-110"
                />
            </a>
        </div>
    );
}

export default Gallary;
